import { useState } from 'react';
import { FilterBox, CheckboxItem } from 'Elements';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedFilter } from 'Actions';
import { Volume, Video, Photo } from 'tabler-icons-react';

export const FilterBoxStoryFile = ({ onChange }) => {
	const filters = useSelector((state) => state.fltr);
	const dispatch = useDispatch();
	const [files] = useState({
		list: [
			{
				id: 0,
				type: 'image',
				title: 'تصویر',
				icon: Photo
			},
			{
				id: 1,
				type: 'video',
				title: 'ویدیو',
				icon: Video
			},
			{
				id: 2,
				type: 'audio',
				title: 'صوت',
				icon: Volume
			}
		],
		image: filters.selected_filter.has_image,
		video: filters.selected_filter.has_video,
		audio: filters.selected_filter.has_audio
	});

	const handleCheckbox = (item, isChecked) => {
		const selected_files = files;
		selected_files[item] = isChecked ? 1 : 0;
		dispatch(
			setSelectedFilter({
				name: [`has_${item}`],
				value: selected_files[item]
			})
		);
		onChange?.();
	};

	return (
		<FilterBox title="روایت دارای">
			{files.list.map((elem) => {
				return (
					<CheckboxItem
						key={elem.id}
						id={`check_${elem.type}_${elem.id}`}
						item={elem.type}
						label={elem.title}
						isChecked={filters.selected_filter[`has_${elem.type}`]}
						icon={elem.icon}
						onChange={handleCheckbox}
					/>
				);
			})}
		</FilterBox>
	);
};
